import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "23px",
  height: "23px",
  viewBox: "0 0 48 48",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<title>icon-list-bull-square</title><desc>Created with Sketch.</desc><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#000000\" x=\"8\" y=\"11\" width=\"6\" height=\"6\"></rect><rect fill=\"#000000\" x=\"8\" y=\"21\" width=\"6\" height=\"6\"></rect><rect fill=\"#000000\" x=\"8\" y=\"31\" width=\"6\" height=\"6\"></rect><rect fill=\"#000000\" opacity=\"0.7\" x=\"18\" y=\"12\" width=\"22\" height=\"4\"></rect><rect fill=\"#000000\" opacity=\"0.7\" x=\"18\" y=\"22\" width=\"22\" height=\"4\"></rect><rect fill=\"#000000\" opacity=\"0.7\" x=\"18\" y=\"32\" width=\"22\" height=\"4\"></rect></g>", 4)


export default /*#__PURE__*/_defineComponent({
  __name: 'squareList',
  props: {
  fillColor: { type: String, default: '#fff' },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createCommentVNode(" Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch "),
    _hoisted_2
  ]))
}
}

})